<template lang="pug">
  div(@keyup.ctrl.enter='scroll_button_handle')
    #editor-container.paragraph(autofocus contenteditable v-scroll='handle_scroll' @input='input_handle')
    div
      .anchor(ref='anchor')
    vs-button.scroll-button(ref='scroll_button' transparent size='large' @click='scroll_button_handle'
      :class='{shown: show_scroll_button, loading: waiting_for_response}')
      | {{ waiting_for_response ? '' : 'Scroll down to continue.' }}

</template>

<script>
import axios from 'axios'

export default {
  name: 'Editor',
  data: () => ({
    waiting_for_response: false,
    show_scroll_button: false,
  }),
  methods: {
    async complete_text(el) {
      while (this.scrolled_down()) {
        await axios.post(' https://pelevin.gpt.dobro.ai/generate/', {
          prompt: el.innerText,
          length: 50,
        }).then((response) => {
          let text = response.data['replies'][0]
          el.appendChild(document.createTextNode(text))
        }).catch((error) => {
          console.log(error)
        })
      }
    },

    scrolled_down() {
      let bottom_scroll_position = document.documentElement.scrollTop + window.innerHeight
      return document.documentElement.offsetHeight - bottom_scroll_position <= window.innerHeight * 0.05
    },

    handle_scroll(evt, el) {
      if (!this.show_scroll_button || this.waiting_for_response) {
        return
      }

      if (this.scrolled_down()) {
        this.waiting_for_response = true
        let loading = this.$vs.loading({
          target: this.$refs.scroll_button,
          type: 'points',
          opacity: '0',
        })

        this.complete_text(el).then(() => {
          this.waiting_for_response = false
          loading.close()
        })
      }
    },

    scroll_button_handle() {
      this.$refs.anchor.scrollIntoView({
        behavior: 'smooth',
        block: 'start',
      })
    },

    input_handle(evt) {
      this.show_scroll_button = evt.target.innerText.length > 3
    }
  }
}
</script>

<style scoped lang="less">
#editor-container {
  font-size: 2rem;
  line-height: 180%;
  cursor: text;
}

:focus {
  outline: none;
}

.paragraph:empty:before{
  content: 'Enter the beginning of the text...';
  color: #777777;
  font-style: italic;
}

.scroll-button {
  margin: 0.5rem 0 0 -14px;
  min-height: 32px;
  min-width: 80px;

  opacity: 0;
  transition: opacity 0.3s linear;


  &.shown {
    opacity: 1;
  }

  &.loading {
    margin-top: 1rem;
  }
}

.anchor {
  position: relative;
  top: -30vh;
}
</style>